import BundleFactory from "./BundleFactory";
import { BundleProductLines } from "../../../constants/BundleProductLines";

export default class ManhattanFactoryProducer {

  static  getProductFactory(make: string) {
    switch (make) {
    case BundleProductLines.PURE_OTT:
    case BundleProductLines.FTTH:
      return new BundleFactory();
    }

    return new BundleFactory();
  }

}
